import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * Get the details of blocks and widgets present on a livepage
 * @param  {string} searchQuery
 * @category Venue Builder
 */
const getPeopleById = async (projectId, peopleId) => {
    try {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/projects/${projectId}/getpeople`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    peopleId: peopleId
                })
            }
        );

        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};
export default getPeopleById;
